import { render, staticRenderFns } from "./success-message.vue?vue&type=template&id=384fe0cd&scoped=true&"
import script from "./success-message.vue?vue&type=script&lang=js&"
export * from "./success-message.vue?vue&type=script&lang=js&"
import style0 from "./success-message.vue?vue&type=style&index=0&id=384fe0cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fe0cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
